module.exports = __webpack_public_path__ + "static/media/hand-paper.3e551123.svg";